'use client';

import { FeatureFlagProvider, useNextgenRouter } from '@nextgen-web-framework/all';
import { type FeatureFlag, Logger, StorageService } from '@nextgen-web-framework/core';
import { ReactNode, useEffect, useState } from 'react';
import { FlagValue } from '@openfeature/core';
import getPageConfig from 'app/utils/page-configs/getPageConfigForISR';
import getRouteFromPathname from 'app/utils/page-configs/getRouteFromPathname';
import logObject from 'utils/logObject';
import Configs from 'constants/configs';

type FeatureFlagsProviderWrapperProps = {
  children?: ReactNode;
};

const logger = Logger.getInstance(logObject('FeatureFlagsProviderWrapper.tsx'));

const FeatureFlagsProviderWrapper = ({ children }: FeatureFlagsProviderWrapperProps) => {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlag>({});
  const router = useNextgenRouter();

  useEffect(() => {
    let profiles: string[] = [Configs.WEBSHOP_FEATURE_FLAG_PROFILE_ID];
    const pageConfigData = getPageConfig(
      getRouteFromPathname(router?.pathname as string, PreferenceService.getPreferences().locale as string) as string,
    );
    const featureFlagProfiles = pageConfigData?.featureFlagProfiles;
    if (Array.isArray(featureFlagProfiles) && featureFlagProfiles?.length) {
      profiles = [...profiles, ...featureFlagProfiles];
    }

    logger.log(
      `Feature flag profiles indentified ${JSON.stringify(profiles)} for the route ${
        router?.pathname || '/'
      } and locale ${PreferenceService.getPreferences().locale}.`,
    );
    let evaluatedFlagsAggregatated: { [x: string]: FlagValue } = {};

    const cookie = StorageService.getCookieStorage();
    for (const profile of profiles) {
      const featureFlagsFromCookie = decodeURIComponent(cookie.retrieve(`feature-flags-${profile}`) || '{}');
      evaluatedFlagsAggregatated = {
        ...evaluatedFlagsAggregatated,
        ...JSON.parse(featureFlagsFromCookie),
      };
      logger.log('featureFlagsFromCookie', featureFlagsFromCookie);
    }

    if (featureFlags) {
      // eslint-disable-next-line
      const { flagDefinitions, evaluatedFlags, ...rest } = featureFlags;
      setFeatureFlags({
        ...rest,
        evaluatedFlags: {
          ...evaluatedFlags,
          ...JSON.parse(JSON.stringify(evaluatedFlagsAggregatated)),
        },
      });
    } else {
      setFeatureFlags({
        evaluatedFlags: {
          ...JSON.parse(JSON.stringify(evaluatedFlagsAggregatated)),
        },
      });
    }

    for (const profile of profiles) {
      cookie.remove(`feature-flags-${profile}`);
      logger.log('featureFlagsRemovedFromCookie', ` feature-flags-${profile}`);
    }
  }, [router?.pathname, router?.params?.locale]);

  useEffect(() => {
    logger.log('featureFlags', featureFlags);
  }, [featureFlags]);

  return <FeatureFlagProvider featureFlagData={featureFlags}>{children}</FeatureFlagProvider>;
};

export default FeatureFlagsProviderWrapper;
